export default "__VITE_ASSET__8b731550__"